export default {
      id: "levels-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#levels",
      toString: function () {
        return this.url;
      }
    }